module.exports = __webpack_public_path__ + "src/app/assets/images/radisson.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/radisson.jpg
// module id = 664
// module chunks = 0